import { getDefaultLanguage } from '../../services/translate/translateService';
import {
  GOOGLE_AUTHORIZATION_URL,
  GOOGLE_CLIENT_ID,
  GOOGLE_PROFILE_URL,
  GOOGLE_REDIRECT_URI,
  GOOGLE_VALIDATE_TOKEN_URL
} from '../../config_module';
import {
  getGoogleClassroomCoursesFromBackend,
  shareContentInGoogleClassroomFromBackend
} from '../../services/api/classroomApi';

export const shareContentInGoogleClassroom = async (activityType, content, courseId, sectionId, institutionId) => {
  const language = getDefaultLanguage();

  shareContentInGoogleClassroomFromBackend(sectionId, institutionId, courseId, {
    activityId: content.activityId,
    title: content.name[language] || content.name[Object.keys(content.name)]
  });
};

export const getGoogleClassroomCourses = async () => {
  try {
    const res = await getGoogleClassroomCoursesFromBackend();
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const isGoogleSSOConfigured = () => {
  return (
    GOOGLE_CLIENT_ID &&
    GOOGLE_AUTHORIZATION_URL &&
    GOOGLE_VALIDATE_TOKEN_URL &&
    GOOGLE_REDIRECT_URI &&
    GOOGLE_PROFILE_URL
  );
};
